import { computed } from 'vue'
import type { ComputedRef } from 'vue'
// types
import type { HeaderButtonProps } from '../types/interfaces'

interface HeaderButtonHookOptions {
  props: HeaderButtonProps
  onClick: () => void
}

interface HeaderButtonHookReturn {
  refIsDropdown: ComputedRef<boolean>
  refIsLink: ComputedRef<boolean>
  refChevronName: ComputedRef<'chevron-up' | 'chevron-down'>
  handleClick: () => void
}

export const useHeaderButton = ({ props, onClick }: HeaderButtonHookOptions): HeaderButtonHookReturn => {
  const refIsDropdown = computed<boolean>(() => props.view === 'dropdown')

  const refIsLink = computed<boolean>(() => props.view === 'link' || Boolean(props.url))

  const refChevronName = computed<'chevron-up' | 'chevron-down'>(() => (
    props.open ? 'chevron-up' : 'chevron-down'
  ))

  const handleClick = (): void => {
    onClick()
  }

  return {
    refIsDropdown,
    refIsLink,
    refChevronName,
    handleClick,
  }
}
